import { Link } from "react-router-dom";
import type { NewsArticle } from "@/types";

export default function NewsCard({ article }: { article: NewsArticle }) {
  return (
    <Link
      to={`/news/${article.id}`}
      className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
    >
      <div className="h-24 w-32 shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-28 sm:w-44">
        <img
          src={article.cover}
          alt={`${article.title} 配图`}
          title={`${article.title} · ai短剧资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-400">
          <span className="rounded bg-accent-100 px-2 py-0.5 font-medium text-accent-800">
            {article.category}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.date}
          </span>
        </div>
        <h3 className="mt-2 line-clamp-2 text-sm font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
          {article.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-500">
          {article.summary}
        </p>
      </div>
    </Link>
  );
}